import DashboardComponent from "../Components/Views/DashboardComponent";
import Login from "../Components/Views/Auth/Login";
import { IDashboardRoute } from "../Interfaces/IDashboardRoute";
import {
  Dashboard,
  LocalOffer,
  HelpOutline
} from "@mui/icons-material";
import OrderEditor from "../Components/Views/OrderEditor/OrderEditor";
import { BusinessRules } from "../Components/BusinessRules/BusinessRules";
import BadgeIcon from '@mui/icons-material/Badge';
import GavelIcon from '@mui/icons-material/Gavel';
import PeopleIcon from '@mui/icons-material/People';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { Employees } from "../Components/Employees";
import { EmployeeEdit } from "../Components/EmployeeEdit";
import { EmployeeRoleEdit } from "../Components/Roles/EmployeeRoleEdit";
import TicketSubmission from "../Components/TicketSubmission/TicketSubmission";
import ReleaseNotesPage from "../Components/Views/ReleaseNotesPage/ReleaseNotesPage";
import DescriptionIcon from '@mui/icons-material/Description';
import ScoringAdminPage from "../Components/Views/ScoringAdminPage/ScoringAdminPage";
import { TextMessagesList } from '../Components/Views/TextMessagesList';
import { PeopleAlt, TextsmsRounded } from '@mui/icons-material';
import UserManagementPage from '../Components/UserManagementPage/UserManagementPage';
import OrganizationsPage from '../Components/OrganizationsPage/OrganizationsPage';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ApplicationQueueTabs from "../Components/Views/ApplicationQueues/ApplicationQueueTabs";
import PermissionEditorPage from "../Components/PermissionEditorPage/PermissionEditorPage";

const dashboardRoutes: IDashboardRoute[] = [
  {
    path: "/",
    sidebarName: "Sales",
    component: ApplicationQueueTabs,
    icon: LocalOffer,
    adminRoute: false,
    publicRoute: true,
    showInSidebar: false
  },
  {
    path: "/sales",
    sidebarName: "Sales",
    component: ApplicationQueueTabs,
    icon: LocalOffer,
    adminRoute: false,
    publicRoute: true,
    showInSidebar: true
  },
  {
    path: "/dashboard",
    sidebarName: "Dashboard",
    component: DashboardComponent,
    icon: Dashboard,
    adminRoute: false,
    publicRoute: true,
    showInSidebar: true
  },
  {
    path: "/login",
    sidebarName: "Login",
    component: Login,
    icon: LocalOffer,
    adminRoute: false,
    publicRoute: true,
    showInSidebar: false
  },
  {
    path: "/order/:id/:shouldOpenGeneratePortalLinkDialog?",
    sidebarName: "Order",
    component: OrderEditor,
    icon: LocalOffer,
    adminRoute: false,
    publicRoute: true,
    showInSidebar: false
  },
  {
    path: "/ticket",
    sidebarName: "Help Desk",
    component: TicketSubmission,
    icon: HelpOutline,
    adminRoute: false,
    publicRoute: true,
    showInSidebar: true
  },
  {
    path: "/rules",
    sidebarName: "Rules",
    component: BusinessRules,
    icon: GavelIcon,
    adminRoute: true,
    publicRoute: false,
    showInSidebar: true
  },
  {
    path: "/employees",
    sidebarName: "Employees",
    component: Employees,
    icon: PeopleIcon,
    adminRoute: true,
    publicRoute: false,
    showInSidebar: true,
  },
  {
    path: "/employee/:id?",
    sidebarName: "Employee Edit",
    component: EmployeeEdit,
    icon: PeopleIcon,
    adminRoute: true,
    publicRoute: false,
    showInSidebar: false,
  },
  {
    path: "/employeerole/:id?",
    sidebarName: "Employee Role Edit",
    component: EmployeeRoleEdit,
    icon: AssignmentIndIcon,
    adminRoute: true,
    publicRoute: false,
    showInSidebar: false,
  },
  {
    path: "/releaseNotes",
    sidebarName: "Release Notes",
    component: ReleaseNotesPage,
    icon: DescriptionIcon,
    adminRoute: false,
    publicRoute: true,
    showInSidebar: true,
  },
  {
    path: "/scoring",
    sidebarName: "Scoring",
    component: ScoringAdminPage,
    icon: DescriptionIcon,
    adminRoute: true,
    publicRoute: false,
    showInSidebar: true,
  },
  {
    path: "/text-messages",
    sidebarName: "Text Messages",
    component: TextMessagesList,
    icon: TextsmsRounded,
    adminRoute: false,
    publicRoute: true,
    showInSidebar: true,
    featureFlag: 'TextMessages'
  },
  {
    path: "/users",
    sidebarName: "Users",
    component: UserManagementPage,
    icon: PeopleAlt,
    adminRoute: true,
    publicRoute: false,
    showInSidebar: true,
  },
  {
    path: "/permissions",
    sidebarName: "Permissions",
    component: PermissionEditorPage,
    icon: BadgeIcon,
    adminRoute: true,
    publicRoute: false,
    showInSidebar: true,
  },
  {
    path: "/organizations",
    sidebarName: "Organizations",
    component: OrganizationsPage,
    icon: AccountBalanceIcon,
    adminRoute: true,
    publicRoute: false,
    showInSidebar: true,
   }
];

export default dashboardRoutes;
